export default class ArrayUtils {
    /**
     * 更新数组,若item已存在则将其从数组中删除,若不存在则将其添加到数组
     * **/
    static updateArray(array, item) {
        for (let i = 0, len = array.length; i < len; i++) {
            let temp = array[i];
            if (item === temp || (item.id && temp.id && item.id === temp.id)) return array.splice(i, 1);
        }
        array.push(item);
    }

    /**
     * 判断两个数组的是否相等
     * @return boolean true 数组长度相等且对应元素相等
     * */
    static isEqual(arr1, arr2) {
        if (!(arr1 && arr2)) return false;
        if (arr1.length !== arr2.length) return false;
        for (let i = 0, l = arr1.length; i < l; i++) {
            if (arr1[i] !== arr2[i]) return false;
        }
        return true;
    }

    /**
     * clone 数组
     * @return Array 新的数组
     * */
    static clone(from) {
        if (!from) return [];
        let newArray = [];
        for (let i = 0, l = from.length; i < l; i++) {
            newArray[i] = from[i];
        }
        return newArray;
    }

    /**
     * 将数组中指定元素移除
     * **/
    static remove(array, item) {
        if (!array) return;
        for (let i = 0, l = array.length; i < l; i++) {
            if (item === array[i]) return array.splice(i, 1);
        }
    }

    /**
     * 判断是数组
     * @param obj
     * @returns {boolean}
     */
    static isArray(obj) {
        return typeof obj === 'object' && obj.constructor === Array
    }


    //查找制定元素在数组中的索引值
    static indexof(arrays, obj) {
        let i = arrays.length;
        while (i--) {
            if (arrays[i] === obj) {
                return i;
            }
        }
        return false;
    }
}
